export const getAccountsDropdownMenuItemStyles = (_, { palette = {} }) => ({
  container: {
  },
  toggleable: {
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
    },
    '&:active': {
      textDecoration: 'none',
    },
    '&:focus': {
      textDecoration: 'none',
    },
  },
  item: {
    lineHeight: '20px',
  },
  itemText: {
  },
  hiddenTooltip: {
  },
  fallbackGlyph: {
    fontSize: '16px',
    paddingLeft: '8px',
    color: palette.themePrimary,
  },
  calloutTargetContainer: {
  },
  menuItemTagContainer: {
    position: 'absolute',
    right: 0,
    marginTop: '-12px',
  },
});
